import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from 'environment';
import { map } from 'rxjs/operators';
import { IncidentService } from '../service/incident.service';
import { WindowLocationToken } from '../util/window.location.token';

export const UserPermissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const incidentService = inject(IncidentService);
  const router = inject(Router);
  const location = inject(WindowLocationToken);

  return incidentService.getUserProfile().pipe(
    map((data: any) => {
      //User has View Escalation Permission
      if (data != null && data._links != null && data._links[environment.ESCALATION_WIDGET_NAME] != null) {
        return true;
      }
      location.href = location.origin + '/404';
      return false;
    }),
  );
};
